import './styles/button.less';
import './styles/die.less';
import './styles/portraits.less';
import './app.css';
import App from './App.svelte';
import './lib/models/traits/index';
import './lib/models/status-effects/index';
//@ts-ignore
import { registerSW } from 'virtual:pwa-register';
import { confirm } from './lib/modals/modals';
import { mount } from 'svelte';

const app = mount(App, {
  target: document.getElementById('app')!,
});

export default app;

const updateSW = registerSW({
  async onNeedRefresh() {
    // confirm() rejects when the player declines; the update then waits for the next visit.
    try {
      await confirm({
        title: 'Update to the latest version?',
        text: 'A new version of the app is available. Do you want to update now?',
      });
    } catch {
      return;
    }
    updateSW();
  },
  onOfflineReady() {},
});
